import { render, staticRenderFns } from "./FaqAdmin.vue?vue&type=template&id=fdc0f41c&scoped=true&lang=pug"
import script from "./FaqAdmin.vue?vue&type=script&lang=js"
export * from "./FaqAdmin.vue?vue&type=script&lang=js"
import style0 from "./FaqAdmin.vue?vue&type=style&index=0&id=fdc0f41c&prod&scoped=true&lang=css"
import style1 from "./FaqAdmin.vue?vue&type=style&index=1&id=fdc0f41c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc0f41c",
  null
  
)

export default component.exports